module.exports = __webpack_public_path__ + "static/media/U region.cc63f523.jpg";